<template>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button @click="cerrarModal();">
          <ion-icon slot="icon-only"  name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>USUARIO</ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-content>
    <ion-grid v-if="cargando || cargandoEmpresas || cargandoSucursales || cargandoTipoUsuario" class="ion-text-center ion-margin-top ion-padding-top">
      <ion-row class="ion-justify-content-center ion-margin-top ion-padding-top">
        <ion-col size="12">
          <ion-spinner name="lines" style="width:80px; height:80px;"></ion-spinner>
        </ion-col>
        <ion-col size="12">
          <ion-label color="dark">CARGANDO...</ion-label>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-list v-else>
      <ion-item>
        <ion-label position="floating">RUT</ion-label>
        <ion-input maxlength="12" v-model="usuario.rutF" @ionChange="usuario.rutF = formateaRut(usuario.rutF)"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="floating">NOMBRES</ion-label>
        <ion-input class="text-uppercase" v-model="usuario.nombres"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="floating">APELLIDO PATERNO</ion-label>
        <ion-input class="text-uppercase" v-model="usuario.apellidoP"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="floating">APELLIDO MATERNO</ion-label>
        <ion-input class="text-uppercase" v-model="usuario.apellidoM"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="floating">CORREO</ion-label>
        <ion-input class="text-lowercase" type="email" v-model="usuario.correo"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="floating">TELÉFONO</ion-label>
        <ion-input class="text-lowercase" type="tel" inputmode="tel" v-model="usuario.telefono" maxlength="9"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="floating">EMPRESA</ion-label>
        <ion-select placeholder="SELECCIONA UNO" v-model="usuario.empresa" cancel-text="CANCELAR" ok-text="ACEPTAR"
          @ionChange="listarSucursales(usuario.empresa); listarTiposUsuario(usuario.empresa); usuario.sucursal=usuario.tipoUsuario=''">
          <ion-select-option v-for="empresa in empresas" :key="empresa.emp_id+'emp'" :value="empresa.emp_id">{{empresa.emp_nombre}}</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-label position="floating">SUCURSAL</ion-label>
        <ion-select :disabled="usuario.empresa==''" placeholder="SELECCIONA UNO" v-model="usuario.sucursal" cancel-text="CANCELAR" ok-text="ACEPTAR">
          <ion-select-option v-for="sucursal in sucursales" :key="sucursal.suc_id+'suc'" :value="sucursal.suc_id">{{sucursal.suc_nombre}}</ion-select-option>
          <ion-select-option :value="''">NINGUNA</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-label position="floating">TIPO USUARIO</ion-label>
        <ion-select :disabled="usuario.empresa==''" placeholder="SELECCIONA UNO" v-model="usuario.tipoUsuario" cancel-text="CANCELAR" ok-text="ACEPTAR">
          <ion-select-option v-for="tipo in tiposUsuario" :key="tipo.tpu_id+'tpu'" :value="tipo.tpu_id">{{tipo.tpu_nombre}}</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-label position="fixed">HABILITADO</ion-label>
        <ion-toggle
          slot="end" color="success"
          @ionChange="usuario.activo = !usuario.activo"
          :checked="usuario.activo">
        </ion-toggle>
      </ion-item>
    </ion-list>
  </ion-content>

  <ion-footer>
    <ion-grid>
      <ion-row>
        <ion-col>
            <ion-button @click="cerrarModal()" color="danger" shape="round" expand="block">
                <ion-label>CERRAR</ion-label>
            </ion-button>
        </ion-col>
        <ion-col>
            <ion-button :disabled="!validaDatos()" @click="registrarUsuario();" color="success" shape="round" expand="block">
                <ion-label>REGISTRAR</ion-label>
            </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-footer>
</template>

<script>
import { modalController, IonContent, IonFooter, IonHeader, IonTitle, IonToolbar, IonButtons, IonButton, IonIcon, IonCol, IonRow, IonGrid, 
      IonLabel, IonItem, IonInput, IonSpinner, IonList, IonSelect, IonSelectOption, IonToggle, toastController } from '@ionic/vue';
import { defineComponent } from 'vue';
import { addIcons        } from 'ionicons';
import { arrowBackOutline, trashOutline, settingsOutline } from 'ionicons/icons';
import { Preferences     } from '@capacitor/preferences';
import axios               from 'axios';
import rutaBase            from '@/plugins/variables';

export default defineComponent({
  name: 'ModalNuevoUsuario',
  props: {
    usuarioProp   : Object,
    modal         : Object
  },
  components: { IonContent, IonFooter, IonHeader, IonTitle, IonToolbar, IonButtons, IonButton, IonIcon, IonCol, IonRow, IonGrid, IonLabel, 
  IonItem, IonInput, IonSpinner, IonList, IonSelect, IonSelectOption, IonToggle },
  data(){
    return {
      cargando              : false,
      cargandoEmpresas      : false,
      cargandoSucursales    : false,
      cargandoTipoUsuario   : false,
      usuario               : {rutF:'', nombres:'', apellidoP:'', apellidoM:'', correo:'', telefono:'', empresa:'', sucursal:'', tipoUsuario:'', activo:true},
      empresas              : [],
      sucursales            : [],
      tiposUsuario          : []
    }
  },
  created() {
    addIcons({
      'arrow-back-outline'  : arrowBackOutline,
      'trash-outline'       : trashOutline,
      'settings-outline'    : settingsOutline
    });
  },
  mounted(){
    this.listarEmpresas();
  },
  methods:{

    async listarEmpresas(){
      this.cargandoEmpresas   = true;
      const token             = await Preferences.get({ key: 'token_auth' });
      const headers           = { headers: { 'Authorization': `${token.value}` } };
      axios.post(rutaBase+'/administrador/listarEmpresasPorRut', null, headers).then( resp => {
        this.cargandoEmpresas = false;
        this.empresas = resp.data.empresas;
      }).catch(() =>{
        this.cargandoEmpresas = false;
        this.muestraToast('ERROR AL OBTENER EMPRESAS.');
      });
    },

    async listarSucursales(idEmpresa){
      this.cargandoSucursales  = true;
      const token           = await Preferences.get({ key: 'token_auth' });
      const headers         = { headers: { 'Authorization': `${token.value}` } };
      const dato            = new URLSearchParams();
      dato.append('id_empresa', idEmpresa);
      axios.post(rutaBase+'/administrador/listarSucursalesPorEmpresa', dato, headers).then( resp => {
        this.cargandoSucursales = false;
        this.sucursales  = resp.data.sucursales;
      }).catch(() =>{
        this.cargandoSucursales = false;
        this.muestraToast('ERROR AL OBTENER SUCURSALES.');
      });
    },

    async listarTiposUsuario(idEmpresa){
      this.cargandoTipoUsuario  = true;
      const token               = await Preferences.get({ key: 'token_auth' });
      const headers             = { headers: { 'Authorization': `${token.value}` } };
      const dato                = new URLSearchParams();
      dato.append('id_empresa', idEmpresa);
      axios.post(rutaBase+'/administrador/listarTiposUsuarioPorEmpresa', dato, headers).then( resp => {
        this.cargandoTipoUsuario = false;
        this.tiposUsuario = resp.data.tiposUsuario;
      }).catch(() =>{
        this.cargandoTipoUsuario = false;
        this.muestraToast('ERROR AL OBTENER TIPOS USUARIO.');
      });
    },

    async registrarUsuario(){
      this.cargando  = true;
      const token               = await Preferences.get({ key: 'token_auth' });
      const headers             = { headers: { 'Authorization': `${token.value}` } };
      const dato                = new URLSearchParams();
      const rutLimpio           = this.usuario.rutF.replace(/\./g,'').replace(/[^k|K|\d]/g, '').replace(/-/g, '').trim().toUpperCase();
      this.usuario.rut          = rutLimpio.substr(0, rutLimpio.length-1);
      this.usuario.dv           = rutLimpio.substr(-1, 1);
      dato.append('usuario', JSON.stringify(this.usuario));
      axios.post(rutaBase+'/administrador/registrarUsuario', dato, headers).then( resp => {
        this.cargando = false;
        if(resp.data.key == 1){
          this.muestraToast('DATOS REGISTRADOS CORRECTAMENTE.');
          this.cerrarModal({recargar:true});
        }
        else{
          this.muestraToast('A OCURRIDO UN ERROR.');
        }
      }).catch(() =>{
        this.cargando = false;
        this.muestraToast('ERROR AL REGISTRAR DATOS.');
      });
    },

    validaDatos(){
      if(
        !this.verificaRut(this.usuario.rutF) ||
        this.usuario.nombres          == '' ||
        this.usuario.apellidoP        == '' ||
        this.usuario.apellidoM        == '' ||
        this.usuario.correo           == '' ||
        this.usuario.telefono.length  <9    ||
        Number.isNaN(this.usuario.telefono) ||
        this.usuario.empresa          == '' ||
        this.usuario.sucursal         == '' ||
        this.usuario.tipoUsuario      == '' 
      ){
        return false;
      }
      else {
        return true;
      }
    },

    async cerrarModal(dato=null){
      modalController.dismiss(dato);
    },

    formateaRut(rut){
      const newRut = rut.replace(/\./g,'').replace(/[^k|K|\d]/g, '').replace(/-/g, '').trim().toUpperCase();
      const lastDigit = newRut.substr(-1, 1);
      const rutDigit = newRut.substr(0, newRut.length-1)
      let format = '';
      let i = 0;
      let j = 1;
      for (i = rutDigit.length - 1; i >= 0; i--) {
        const e = rutDigit.charAt(i);
        format = e.concat(format);
        if (j % 3 == 0 && j <= rutDigit.length - 1) {
          format = '.'.concat(format);
        }
        j++;
      }
      let formateado = "";
      if(format.length > 0){
        formateado = format.concat('-').concat(lastDigit);
      }
      else{
        formateado = lastDigit;
      }
      return formateado;
    },

    verificaRut(rut){
      let resp=false;
      if(rut != null && rut.toString().length >= 11){
        const dv = rut.substring(rut.length - 1, rut.length);
        rut = rut.replace(/[.|-]/g, '').slice(0, -1);
        if(rut.indexOf('K') == -1){
        //DESCOMENTAR EL IF Y LA LLAVE PARA VALIDAR CONTRA RUT 'ESPECIALES'
        //if(!rut.match(/(KK|0000000|1111111|2222222|3333333|4444444|5555555|6666666|7777777|8888888|9999999)/g)){
            let m=0,s=1;
            for(;rut;rut=Math.floor(rut/10))
              s=(s+rut%10*(9-m++%6))%11;
            const dvCalc= (s?s-1:'K').toString();
            if(dvCalc===dv) resp=true;
        // }
        }
      }
      return resp;
    },

    async muestraToast(msj='') {
      const toast = await toastController
        .create({
          message: msj,
          duration: 2000,
          cssClass: 'text-center'
        })
      return toast.present();
    }
  }
});
</script>

<style>
.alert-wrapper.sc-ion-alert-md {
  min-width:350px !important;
  max-width:none !important;
}
</style>